import { ApiErrorCodes, ClientError } from '@tribeplatform/gql-client'

export const isNotFound = (error: ClientError) => {
  if (!error) return false
  return error?.response?.errors?.some(
    error => String(error.code) === String(ApiErrorCodes.RESOURCE_NOT_FOUND),
  )
}

export const isForbidden = (error: ClientError) => {
  if (!error) return false
  return error?.response?.errors?.some(
    error => String(error.code) === String(ApiErrorCodes.PERMISSION_ERROR),
  )
}

export const extractErrorMessage = (
  error: ClientError,
  defaultErrorMessage?: string,
) => {
  let errorMessage = defaultErrorMessage || error?.message
  if (error?.response?.errors) {
    errorMessage =
      error.response.errors
        ?.map(e => e?.message)
        .filter(Boolean)
        .join('\n') || errorMessage
  }
  return errorMessage || 'An error occurred'
}
